import React, {
  RefObject,
  SetStateAction,
  useEffect,
  useRef,
  useState,
} from "react";
import { Image, Modal } from "react-bootstrap";
import Slider from "react-slick";
import moment from "moment-timezone";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { saveAs } from "file-saver";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

import dummyImg from "../../assets/img/placeholders/image-placeholder.jpg";
import dummyFile from "../../assets/img/placeholders/file-placeholder.png";

interface PropsType {
  modalShow: boolean;
  setModalShow: React.Dispatch<SetStateAction<boolean>>;
  data: any;
}

const ReportDetailModal: React.FC<PropsType> = ({
  modalShow,
  setModalShow,
  data,
}) => {
  const [urlImg, setUrlImg] = useState<any[]>([]);
  const [urlAudio, setUrlAudio] = useState<any[]>([]);
  const [urlVideo, setUrlVideo] = useState<any[]>([]);
  const [urlFile, setUrlFile] = useState<any[]>([]);

  const slider: RefObject<Slider> = useRef(null);
  const settings = {
    // dots: true,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const getMediaUrl = (url: string) => {
    if (!url) return null;

    const storage = getStorage();
    const imgRef = ref(storage, url);

    const videoExt = ["mov", "mp4", "avi"];
    const imageExt = ["jpeg", "jpg", "png"];
    const audioExt = ["wav", "mp3", "m4a"];

    getDownloadURL(imgRef)
      .then((URL) => {
        const fileExt = url?.split(".").at(url.split(".").length - 1);

        if (videoExt?.indexOf(fileExt || "") !== -1) {
          setUrlVideo((prevState) => (prevState ? [...prevState, URL] : [URL]));
        } else if (audioExt?.indexOf(fileExt || "") !== -1) {
          setUrlAudio((prevState) => (prevState ? [...prevState, URL] : [URL]));
        } else if (imageExt?.indexOf(fileExt || "") !== -1) {
          setUrlImg((prevState) => (prevState ? [...prevState, URL] : [URL]));
        } else {
          setUrlFile((prevState) => (prevState ? [...prevState, URL] : [URL]));
        }

        return URL;
      })
      .catch((error) => {});
    return dummyImg;
  };

  useEffect(() => {
    data?.mediafile && getMediaUrl(data?.mediafile);
    data?.medias &&
      data?.medias?.length > 0 &&
      data?.medias?.map((file: any, index: number) =>
        getMediaUrl(
          data?.medias[index]?.mediaPath || data?.medias[index]?.mediafile,
        ),
      );
  }, [data?.medias, data?.mediafile]);

  return (
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <div className="position-relative h-sm-auto overflow-hidden">
          <Slider
            ref={slider}
            {...settings}
            className="slick-slider-arrow-inner">
            {/* {data?.files.map((a: any, i: any) => {
							return ( */}

            {urlImg &&
              urlImg.map(
                (img, index) =>
                  img && (
                    <div
                      key={index}
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "300px" }}>
                      <FontAwesomeIcon
                        icon={faDownload}
                        className="cursor-pointer"
                        color="white"
                        size="5x"
                        style={{ position: "absolute", opacity: "0.5" }}
                        onClick={() => saveAs(img, img)}
                      />
                      <Image
                        style={{ height: "300px" }}
                        fluid
                        rounded
                        src={img || dummyImg}
                        alt=""
                      />
                    </div>
                  ),
              )}

            {urlVideo &&
              urlVideo.map(
                (vid, index) =>
                  vid && (
                    <video
                      key={index}
                      width="100%"
                      height="300"
                      controls
                      onClick={() => saveAs(vid, vid)}>
                      <source src={vid} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ),
              )}

            {urlAudio &&
              urlAudio.map(
                (aud, index) =>
                  aud && (
                    <div className="d-flex justify-content-center align-items-end w-100">
                      <audio
                        key={index}
                        className="w-100"
                        style={{ height: "300px" }}
                        controls
                        onClick={() => saveAs(aud, aud)}>
                        <source src={aud} type="video/mp4" />
                        Your browser does not support the video tag.
                      </audio>
                    </div>
                  ),
              )}

            {urlFile &&
              urlFile.map(
                (file, index) =>
                  file && (
                    <div
                      key={index}
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "300px" }}>
                      <FontAwesomeIcon
                        icon={faDownload}
                        className="cursor-pointer"
                        color="#b6b6b6"
                        size="5x"
                        style={{ position: "absolute", opacity: "0.8" }}
                        onClick={() => saveAs(file, file)}
                      />
                      <img
                        src={dummyFile}
                        alt="File"
                        style={{ height: "300px" }}
                        onClick={() => saveAs(file, file)}
                      />
                    </div>
                  ),
              )}

            {data?.medias?.length < 1 &&
              !data?.mediafile &&
              urlVideo.length === 1 &&
              urlImg.length === 1 &&
              !urlFile && (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ width: "100%", height: "300px" }}>
                  <p>No Media</p>
                </div>
              )}
            {(data?.medias?.length > 1 || data?.mediafile) &&
              urlImg.length === 1 &&
              urlVideo.length === 1 &&
              !urlFile && (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ width: "100%", height: "300px" }}>
                  Loading
                </div>
              )}
          </Slider>
        </div>
        <div className="overflow-hidden mt-4">
          <h5>{data?.text || "No Text Found"}</h5>
          <p>
            <b>
              {data
                ? moment(data?.createdOn)
                    .tz("Australia/Brisbane")
                    .format("DD-MM-YYYY, h:mm A")
                : "N/A"}
              {/* {moment(data?.publishedOn).tz("Australia/Brisbane").format("DD-MM-YYYY, h:mm A") || "N/A"} */}
            </b>
          </p>
          <p>{data?.description}</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ReportDetailModal;
